<div class=" pad">
    <calsoft-layout [pageNated]="true" [value]="2"></calsoft-layout>
</div>